import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import i18n from '@/i18n'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      titleKey: 'bottomNav.首页'
    }
  },
  {
    path: '/assets',
    name: 'Assets',
    component: () => import('../views/Assets.vue'),
    meta: {
      titleKey: 'assets.我的账户'
    }
  },

  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/Recharge.vue'),
    meta: { titleKey: 'assets.充值', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/withdrawal',
    name: 'Withdrawal',
    component: () => import('../views/Withdrawal.vue'),
    meta: { titleKey: 'assets.提现', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/withdrawal-history',
    name: 'WithdrawalHistory',
    component: () => import('../views/WithdrawalHistory.vue'),
    meta: { titleKey: 'withdrawal.提现记录', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/recharge-history',
    name: 'RechargeHistory',
    component: () => import('../views/RechargeHistory.vue'),
    meta: { titleKey: 'recharge.充值记录', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/recharge-detail/:id',
    name: 'RechargeDetail',
    component: () => import('../views/RechargeDetail.vue'),
    meta: { titleKey: 'recharge.充值详情', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/set-fund-password',
    name: 'SetFundPassword',
    component: () => import('../views/SetFundPassword.vue'),
    meta: { titleKey: 'withdrawal.设置资金密码', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/modify-fund-password',
    name: 'ModifyFundPassword',
    component: () => import('../views/ModifyFundPassword.vue'),
    meta: { titleKey: 'withdrawal.修改资金密码', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/kyc',
    name: 'Kyc',
    component: () => import('../views/Kyc.vue'),
    meta: { titleKey: 'kyc.实名认证', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/kyc/lv1',
    name: 'KycLv1',
    component: () => import('../views/KycLv1.vue'),
    meta: { titleKey: 'kyc.lv1标题', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/kyc/lv2',
    name: 'KycLv2',
    component: () => import('../views/KycLv2.vue'),
    meta: { titleKey: 'kyc.lv2标题', hideBottomNav: true, hideHeader: true }
  },
  {
    path: '/flash-options',
    name: 'FlashOptions',
    component: () => import('../views/FlashOptions.vue'),
    meta: {
      titleKey: 'flashOptions.闪电期权',
      transparentHeader: true,
      hideHeaderActions: true,
      hideHeader: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 设置页面标题的函数
const updatePageTitle = (route) => {
  if (route.meta.titleKey) {
    // 使用翻译键设置页面标题
    const translatedTitle = i18n.global.t(route.meta.titleKey)
    document.title = `${translatedTitle} - ecoWise Renewable Energy`
  } else if (route.meta.title) {
    // 兼容旧的硬编码标题
    document.title = route.meta.title
  }
}

// 路由守卫 - 设置页面标题
router.beforeEach((to, from, next) => {
  updatePageTitle(to)
  next()
})

// 监听语言切换，更新当前页面标题
let currentRoute = null
router.afterEach((to) => {
  currentRoute = to
})

// 导出更新标题函数，供语言切换时调用
window.updateCurrentPageTitle = () => {
  if (currentRoute) {
    updatePageTitle(currentRoute)
  }
}

export default router
